var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "download-cover-config download-video-config-section",
      staticStyle: { display: "flex" },
    },
    [
      _c("div", { staticClass: "download-video-config-title" }, [
        _vm._v("视频快照图："),
      ]),
      _vm._v(" "),
      _c("SwitchBox", {
        model: {
          value: _vm.enabled,
          callback: function ($$v) {
            _vm.enabled = $$v
          },
          expression: "enabled",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }